import { Outlet, useOutletContext } from 'react-router-dom'

import { CostCentersNestedList } from 'modules/cost_centers/components/CostCenterNestedList'

const CostCentersNestedListPage = () => {
  const { canManageCostCenters, hasFeatureCostCenterManagement } = useOutletContext<{
    canManageCostCenters: boolean
    hasFeatureCostCenterManagement: boolean
  }>()

  return (
    <>
      <CostCentersNestedList canManageCostCenters={canManageCostCenters} />
      <Outlet
        context={{
          canManageCostCenters,
          hasFeatureCostCenterManagement,
        }}
      />
    </>
  )
}

export default CostCentersNestedListPage
